import React from "react";
import SEOLandingPage from "./SEOLandingPage";

const TextEditorAndroid: React.FC = () => (
  <SEOLandingPage
    title="Text Editor for Android — Open & Edit Text Files on Your Phone | Cosmovex"
    metaDescription="Text Editor & Viewer for Android. Syntax highlighting, search & replace, line numbers, and dark mode. Edit .txt, .log, .json, .xml, .md files on mobile."
    ogTitle="Text Editor & Viewer for Android"
    h1="Text Editor for Android"
    intro="A lightweight text editor for Android that opens any plain text file with syntax highlighting, search & replace, and line numbers. Edit logs, configs, code snippets, and notes offline."
    paragraphs={[
      "Sometimes you just need to open a text file on your phone and edit it without installing a full IDE. Text Editor & Viewer is that app — lightweight, fast, and capable enough for real editing work on Android.",
      "Open any plain text file: .txt, .md, .log, .json, .xml, .csv, .yaml, config files, shell scripts, and more. If it's readable text, Text Editor can open it. Automatic syntax highlighting detects the file type and applies appropriate color coding — JSON looks like JSON, XML looks like XML, Markdown renders with visible structure.",
      "Find and replace text with full search controls including case-sensitive matching. Line numbers make navigating logs and code easy. Adjust font size to your preference. Auto-save keeps your work safe. The dark theme is built-in and designed for long editing sessions.",
      "No ads, no internet required, no data sent anywhere. Your files stay on your device. Perfect for developers checking log files, sysadmins editing configs, or anyone who needs a reliable text editor on the go.",
    ]}
    features={[
      "Opens any plain text file format",
      "Automatic syntax highlighting by file type",
      "Find & replace with case-sensitive option",
      "Line numbers for navigation",
      "Adjustable font size",
      "Auto-save protects your work",
      "Dark theme built-in",
      "Works completely offline",
      "No ads, no data collection",
      "Share and export edited files",
    ]}
    playStoreUrl="https://play.google.com/store/apps/details?id=com.cosmovex.textvedit"
    icon="/images/textvedit.png"
    appName="Text Editor & Viewer"
    accentColor="#A8720E"
    canonicalPath="/text-editor-android"
  />
);

export default TextEditorAndroid;
